import React, {PropsWithChildren, ReactNode} from "react";
import MessageBox from "./MessageBox";
import {I18nGlobals} from "../translation/i18nInterface";
import {MessageType} from "../log/MessageInterface";
import FunctionHelper from "../helper/FunctionHelper";
import PortalPureComponent from "./PortalPureComponent";

/**
 * globally used properties for {@link Helper} components
 */
export interface HelperGlobals {
	showHelp: boolean;
}

export function initHelperGlobals(): HelperGlobals {
	return {
		showHelp: false
	};
}

/**
 * The properties for a {@link Helper} component
 */
interface HelperProperties extends HelperGlobals, I18nGlobals {
	type?: MessageType;
}

/**
 * A help message that will be shown if the global showHelp option is active
 */
export default class Helper extends PortalPureComponent<PropsWithChildren<HelperProperties>, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<>
				<div className={"helper" + (this.props.showHelp ? " active" : "")}>
					<MessageBox {...this.props}
								type={FunctionHelper.exists(this.props.type) ? this.props.type : MessageType.HELP}>
						{this.props.children}
					</MessageBox>
				</div>
			</>
		);
	}
}